import Vue from 'vue'
import { Button, Dialog, Steps, Upload } from 'element-ui'


Vue.use(Button)
Vue.use(Dialog)
Vue.use(Steps)
Vue.use(Upload)